export default function block_posts() {
  if ($('.felds-latest-posts-block').length == 0) return;

  $('.felds-latest-posts-block .block-filter #filter-year').select2();

  $('.felds-latest-posts-block .block-filter #filter-year').on('select2:select', function (e) {
    var params = '';

    var filter_year = $('.felds-latest-posts-block .block-filter #filter-year').val();
    if (filter_year) {
      params = '?filter_year=' + filter_year;
    }

    location = $('.felds-latest-posts-block .block-filter').data('url') + params;
  });
}
